import React, { useState, useEffect, useRef } from 'react';
import {
  useSlateStatic,
  ReactEditor
} from 'slate-react';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import * as collectionUtilities from 'utilities/collection';

import HelptapEditor from '../../helpers';
import BaseElement from '../base';

function SingleProducerMeeting(props) {

  const element = props.element;
  const attributes = element.attributes || element.options || {};

  const isLoaded = useRef(false);

  const [rootState, setRootState] = useState({
    ...attributes,
    meeting: null
  });
  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  useEffect(function onLoad() {

    tryShowDeviceAccessErrors();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes.error]);

  useEffect(function onLoad() {

    if (isLoaded.current === true) {
      return;
    }

    isLoaded.current = true;

    initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isLiveStreamingMinutesAvailableError(exception) {

    if (exception.code !== 'ValidationError') {
      return false;
    }

    const metadata = exception.metadata;

    const errorIndex = collectionUtilities.findIndexByPropertyValue(metadata, 'keyword', 'isLiveStreamingMinutesAvailable');

    if (errorIndex === -1) {
      return false;
    }

    return true;

  }

  async function initialize() {

    try {

      const meeting = await serverInterface.startup.community.singleProducerMeeting.createOrGetSingleProducerMeetingByOwnerIdAndPostId(rootState.postId);

      setRootState({
        ...rootState,
        meeting
      });

    } catch (exception) {
      console.log(exception);
      if (isLiveStreamingMinutesAvailableError(exception) === true) {
        application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
          message: 'Unable to create live stream. Live Stream minutes unavailable',
          seconds: 5,
          type: 'error'
        });
      } else {
        application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
          message: 'Unable to create live stream. Unknown error',
          seconds: 5,
          type: 'error'
        });
      }

      // deleting live streaming element
      HelptapEditor.deleteNodeByPath(editor, elementPath);
      // deleting the empty paragraph node after that, which was created while added live stream element
      HelptapEditor.deleteNodeByPath(editor, elementPath);

    }

  }

  function tryShowDeviceAccessErrors() {

    if (rootState.error !== true) {
      return;
    }

    application.devicesManager.ensureMediaPermissions();

  }

  function doRenderSingleProducerMeeting() {

    if (rootState.meeting === null) {
      return <ht-spinner/>;
    }

    const singleProducerMeetingAttriputes = {
      postId: rootState.postId,
      editor: true
    };

    return <ht-single-producer-meeting {...singleProducerMeetingAttriputes}></ht-single-producer-meeting>;

  }

  function renderSingleProducerMeeting() {

    const mainAttributes = {
      ...props.attributes,
      contentEditable: false,
      className: 'single-producer-meeting-element'
    };

    return <div {...mainAttributes}>
      {props.children}
      {doRenderSingleProducerMeeting()}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'single-producer-meeting-wrapper'
    };

    return <BaseElement {...baseElementProperties}>
      {renderSingleProducerMeeting()}
    </BaseElement>;

  }

  return renderMain();

}

export default SingleProducerMeeting;